import { store } from '../state.js';
import { formatMoney, formatDate, daysAgo } from '../utils.js';
import { showToast } from '../toast.js';

let operationsFilter = 'all';

const DOCUMENTS = [
    { label: monthLabel(1), type: 'act' },
    { label: monthLabel(2), type: 'act' },
    { label: 'Акт сверки за квартал', type: 'reconciliation' }
];

function monthLabel(monthsAgo) {
    const d = new Date();
    d.setMonth(d.getMonth() - monthsAgo);
    return `Акт за ${d.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' })}`;
}

function opLabel(op) {
    if (op.type === 'topup') return `Пополнение · ${op.method || ''}`;
    if (op.type === 'refund') return 'Возврат за брак';
    return 'Списание за заявку';
}

export function renderFinance(container) {
    const state = store.get();
    const avgSpendPerDay = state.leads.filter(l => l.createdAt >= daysAgo(7)).reduce((sum, l) => sum + l.cost, 0) / 7;
    const forecastDays = avgSpendPerDay > 0 ? Math.round(state.balance / avgSpendPerDay) : 0;

    const operations = state.operations.filter(op => operationsFilter === 'all' || op.type === operationsFilter);

    container.innerHTML = `
        <div class="fin-grid">
            <div class="fin-balance">
                <div class="fin-balance__label">Баланс</div>
                <div class="fin-balance__value">${formatMoney(state.balance)}</div>
                <div class="fin-balance__forecast">При текущем темпе хватит примерно на <b>${forecastDays} дня</b> — в среднем ${formatMoney(avgSpendPerDay)} в день</div>
                <button type="button" class="fin-balance__btn" id="fin-topup">Пополнить баланс</button>
            </div>

            <div class="fin-card">
                <div class="fin-card__title">Напоминание о балансе</div>
                <p class="fin-card__desc">Пришлём письмо и сообщение в Telegram, когда баланс опустится ниже суммы:</p>
                <div class="fin-threshold">
                    <input type="number" id="fin-threshold-input" value="${state.balanceThreshold}" step="500" min="0">
                    <button type="button" id="fin-threshold-save">Сохранить</button>
                </div>

                <div class="fin-card__title fin-card__title--mt">Документы</div>
                <div class="fin-docs">
                    ${DOCUMENTS.map((doc, i) => `
                        <div class="fin-docs__row">
                            <span>${doc.label}</span>
                            <button type="button" class="fin-docs__btn" data-doc="${i}">Отправить на почту</button>
                        </div>
                    `).join('')}
                </div>
            </div>
        </div>

        <div class="fin-card">
            <div class="fin-card__head">
                <div class="fin-card__title">Операции</div>
                <select id="fin-op-filter">
                    <option value="all" ${operationsFilter === 'all' ? 'selected' : ''}>Все операции</option>
                    <option value="topup" ${operationsFilter === 'topup' ? 'selected' : ''}>Пополнения</option>
                    <option value="charge" ${operationsFilter === 'charge' ? 'selected' : ''}>Списания</option>
                    <option value="refund" ${operationsFilter === 'refund' ? 'selected' : ''}>Возвраты</option>
                </select>
            </div>
            <div class="fin-ops">
                ${operations.slice(0, 60).map(op => `
                    <div class="fin-ops__row">
                        <div>
                            <div class="fin-ops__label">${opLabel(op)}${op.leadId ? ` <a href="javascript:" class="fin-ops__link" data-lead="${op.leadId}">№${(store.getLead(op.leadId) || {}).number || ''}</a>` : ''}</div>
                            <div class="fin-ops__date">${formatDate(op.date)}</div>
                        </div>
                        <div class="fin-ops__amount ${op.amount >= 0 ? 'positive' : 'negative'}">${op.amount >= 0 ? '+' : ''}${formatMoney(op.amount)}</div>
                    </div>
                `).join('') || '<div class="fin-ops__empty">Операций пока нет</div>'}
            </div>
        </div>
    `;

    container.querySelector('#fin-topup').addEventListener('click', () => {
        document.querySelector('#open-topup').click();
    });

    container.querySelector('#fin-threshold-save').addEventListener('click', () => {
        const value = parseInt(container.querySelector('#fin-threshold-input').value, 10) || 0;
        store.update(s => { s.balanceThreshold = value; });
        showToast('Порог напоминания сохранён');
    });

    container.querySelectorAll('.fin-docs__btn').forEach(btn => {
        btn.addEventListener('click', () => showToast('Документ отправлен на почту'));
    });

    container.querySelector('#fin-op-filter').addEventListener('change', e => {
        operationsFilter = e.target.value;
        renderFinance(container);
    });

    container.querySelectorAll('.fin-ops__link').forEach(link => {
        link.addEventListener('click', async () => {
            const { renderLeadPanel } = await import('../leadPanel.js');
            renderLeadPanel(link.dataset.lead);
        });
    });
}
